import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { BsCurrencyRupee } from "react-icons/bs";
import { Link, useParams } from 'react-router-dom';
import { useState } from 'react';
import axiosInterceptor from '../function/axiosInterceptor'
const DonateUser_dt = () => {
    const empty = { name: '', phone: '', email: '', amount: '', pan: '', btnLoader: false }
    const [data, setData] = useState(empty)
    const SubmitForm = async (event) => {
        event.preventDefault();
        try {
            setData(prev => ({ ...prev, btnLoader: true }))
            if (!data?.amount || Number(data?.amount || 0) <= 0) {
                toast.warn("Enter valid amount...!!", { position: 'top-center', autoClose: 700 });
                return;
            }
            const response = await axiosInterceptor.post('/quickdonate', data)
            const { status, message } = response || {}
            console.log(response, status, message);
            
            if (status !== 'success') {
                toast.warn(message, { position: 'top-center', autoClose: 700 }); return
            }
            setData(prev => ({ ...prev, ...empty }))
            toast.success(message, { position: 'top-center', autoClose: 1000 }); return
        } catch (err) {
            toast.error(err.message, { position: 'top-center', autoClose: 700 })
        } finally {
            setData(prev => ({ ...prev, btnLoader: false }))
        }
    }
    return (<>
        <ToastContainer />
        <div className="wrapper">
            <div class="container">


                <div class="row justify-content-between align-items-center">

                    <div class="col-xxl-6 m-auto mt-5">
                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h4 class="header-title">MNB Foundation Donation</h4>
                                <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#standard-modal">UPI QR</button>
                            </div>
                            <img src="https://api.mnbfoundation.com/img/6122023_9950917.png" className='m-auto donates-logo' />
                            <div class="alert alert-warning mt-2 text-center py-2 border-0 rounded-0" role="alert">
                                <i class="uil-folder-heart me-1 h4 align-middle"></i>Serving humanity with heart and action.
                            </div>
                            <div class="card-body pt-1">
                                <form class="row g-2 donates" onSubmit={SubmitForm}>
                                    <div class="col-md-12 mt-3">
                                        <label htmlFor="amt" class="form-label mb-0">Amount <code>*</code></label>
                                        <input type="number" class="form-control" id="amt" name="amount" placeholder='0.00' value={Number(data?.amount || 0) || ''} onChange={(e) => setData((prev) => ({ ...prev, amount: e.target.value }))} required />
                                    </div>
                                    <div class="col-md-6 col-sm-6 mt-3">
                                        <label htmlFor="name" class="form-label mb-0">Name <code>*</code></label>
                                        <input type="name" class="form-control" id="name" name="name" placeholder='enter name' value={data.name} onChange={(e) => setData((prev) => ({ ...prev, name: e.target.value }))} required />
                                    </div>
                                    <div class="col-md-6 col-sm-6 mt-3">
                                        <label htmlFor="email" class="form-label mb-0">Email </label>
                                        <div class="input-group">
                                            <span class="input-group-text" id="email">@</span>
                                            <input type="email" class="form-control" placeholder="example@gmail.com" id="email" name='email' value={data.email} onChange={(e) => setData((prev) => ({ ...prev, email: e.target.value }))} />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 mt-3">
                                        <label htmlFor="phone" class="form-label mb-0">Mobile </label>
                                        <div class="input-group">
                                            <span class="input-group-text" id="phone">+91</span>
                                            <input type="number" class="form-control" placeholder="enter mobile no" id="phone" name='phone' value={data.phone} onChange={(e) => setData((prev) => ({ ...prev, phone: e.target.value }))} />
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-sm-6 mt-3">
                                        <label htmlFor="pan" class="form-label mb-0">PAN Number</label>
                                        <input type="text" class="form-control" placeholder="enter pan no" id="pan" name='pan' value={data.pan} onChange={(e) => setData((prev) => ({ ...prev, pan: e.target.value }))} />
                                    </div>

                                    <div class="col-12 mt-3">
                                        {data?.btnLoader?<button type="button" class="btn btn-primary w-100 mx-0" disabled><div class="spinner-border" role="status" style={{ width: '17px', height: '17px'}}></div></button>:<button type="submit" class="btn btn-primary w-100 mx-0">Continue</button>}
                                    </div>
                                </form>

                                <p class="text-muted text-center mt-3">Back to Home page <Link to="/" class="text-primary fw-semibold ms-1">click here</Link></p>



                                <div id="standard-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel" aria-hidden="true">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h4 class="modal-title" id="standard-modalLabel">MNB Foundation QR</h4>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"></button>
                                            </div>
                                            <div class="modal-body ">
                                                <img src="/main/files/static/qr.png" width={270} className='mt-3 m-auto' />
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default DonateUser_dt;

